import { classnames } from '@aibees/shared/utils';
import { forwardRef, lazy } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichmentPageProps as Props } from './types';

const CsvEnrichment = lazy(() =>
  import('@aibees/elephant/components/csv-enrichment').then((module) => ({
    default: module.CsvEnrichment,
  }))
);

export const EnrichmentPage = forwardRef<HTMLDivElement, Props>(
  ({ className }, ref) => {
    return (
      <Styled.Wrapper
        className={classnames('EnrichmentPage', className)}
        ref={ref}
        sx={SX.root}
      >
        <CsvEnrichment />
      </Styled.Wrapper>
    );
  }
);
